"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MONTH_COUNT_MOBILE = exports.MONTH_COUNT = exports.MAXIMUM_SHOW_HOTEL_DAYS = exports.MAXIMUM_SHOW_DAYS = exports.MAXIMUM_NIGHTS = void 0;
var MONTH_COUNT = 2;
exports.MONTH_COUNT = MONTH_COUNT;
var MONTH_COUNT_MOBILE = 1;
exports.MONTH_COUNT_MOBILE = MONTH_COUNT_MOBILE;
var MAXIMUM_NIGHTS = 30;
exports.MAXIMUM_NIGHTS = MAXIMUM_NIGHTS;
var MAXIMUM_SHOW_DAYS = 365;
exports.MAXIMUM_SHOW_DAYS = MAXIMUM_SHOW_DAYS;
var MAXIMUM_SHOW_HOTEL_DAYS = 730;
exports.MAXIMUM_SHOW_HOTEL_DAYS = MAXIMUM_SHOW_HOTEL_DAYS;